import { render, staticRenderFns } from "./Go.vue?vue&type=template&id=020a8ff8&scoped=true"
import script from "./Go.vue?vue&type=script&lang=js"
export * from "./Go.vue?vue&type=script&lang=js"
import style0 from "./Go.vue?vue&type=style&index=0&id=020a8ff8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a8ff8",
  null
  
)

export default component.exports